export default "__VITE_ASSET__bbztGsvRzukDiwtnhHuagA__";